import { gql } from '@apollo/client';

export const CHECK_USER_PEN_NAME = gql`
	mutation CheckUserPenName($pen_name: String!) {
		checkUserPenName(pen_name: $pen_name)
	}
`;
